import { MdsIconKind } from "@/design-system/components/icon";
import { getIconKind } from "@/design-system/components/item-list/rows/icon/icon-kind";
import { MDSIconButton, MDSIconButtonVariant } from "@/mds";
import styled from "@emotion/styled";

interface Props {
  isSelected?: boolean;
  isHighlighted?: boolean;
  toggleSelected?: (event: React.MouseEvent) => void;
}

export function DateIcon({ isSelected, isHighlighted, toggleSelected }: Props) {
  return (
    <StyledIconButton
      onClick={toggleSelected}
      variant={MDSIconButtonVariant.Transparent}
      iconKind={getIconKind({ isSelected, isHighlighted, defaultIcon: MdsIconKind.CalendarDay })}
      $isSelected={isSelected}
    />
  );
}

const StyledIconButton = styled(MDSIconButton)<{ $isSelected?: boolean }>`
  padding: 0px;
  height: 16px;
  width: 16px;

  .mds-icon {
    font-size: 18px;
    height: 18px;
    width: 18px;
    color: ${({ $isSelected, theme }) =>
      $isSelected ? theme.colors.mblue.x500 : theme.colors.icon.placeholder};
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
`;
